import { createSignal } from '@verclam/pulsar';

/** `null` when no deletion is pending confirmation; otherwise the id of the interview to confirm. */
const interviewToDeleteSignal = createSignal<number | null>(null);

export const openInterviewToDelete = (interviewId: number): void => {
	interviewToDeleteSignal.value = interviewId;
};

export const closeInterviewToDelete = (): void => {
	interviewToDeleteSignal.value = null;
};

export default interviewToDeleteSignal;
